import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTableDataSourcePageEvent } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'fury-customer-agreement-list',
  templateUrl: './customer-agreement-list.component.html',
  styleUrls: ['./customer-agreement-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CustomerAgreementListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  displayedColumns: any = ['agreementNumber', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;

  constructor(
    private api: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1: 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;    
    });
  }

  ngOnInit(): void {
    this.getCustomerAgreement();
  }
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(`/customer-agreement/customer-agreement-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}`);
    this.getCustomerAgreement();
}

pageSizeChange(event: any) {    
  this.pageSize = event.pageSize;
  this.pageIndex = event.pageIndex;
  this.router.navigateByUrl(`/customer-agreement/customer-agreement-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}`);
  this.getCustomerAgreement();
}

  getCustomerAgreement(){
    this.api.get(`admin/customer-agreement/get-customer-agreements?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}`).subscribe((res:any)=>{
      if(res.body){
        this.itemList = res?.body?.customerAgreements?.data;
        this.dataSource = res?.body?.customerAgreements?.data;
        this.totalCount = res?.body?.customerAgreements?.total;
        this.cdr.detectChanges();
      }
    })
  }

}
